import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  question: 'Do you accept first-time clients?',
  answer: 'Yes, I welcome both experienced practitioners and those new to BDSM. First-time clients will go through a more detailed consultation to ensure comfort and safety.'
}, {
  question: 'What is your cancellation policy?',
  answer: 'Sessions must be cancelled at least 48 hours in advance for a full refund. Cancellations within 48 hours will forfeit 50% of the session fee. Same-day cancellations forfeit the full amount.'
}, {
  question: 'Do you offer couples sessions?',
  answer: 'Yes, I offer sessions for couples interested in exploring power dynamics together. Both parties must complete the screening process independently.'
}, {
  question: 'What should I bring to my first session?',
  answer: 'Bring the agreed-upon tribute in a sealed envelope, any requested paperwork, and an open mind. All equipment and supplies are provided.'
}, {
  question: 'How long are typical sessions?',
  answer: 'Sessions range from 90 minutes to 4 hours, depending on the experience and your availability. Longer sessions allow for deeper exploration and more complex scenes.'
}, {
  question: 'Do you travel for sessions?',
  answer: 'I occasionally travel for established clients. Travel sessions require advance booking, additional fees, and thorough planning.'
}, {
  question: 'What is your approach to safety?',
  answer: 'Safety is paramount. I am trained in risk-aware consensual kink (RACK), maintain sanitized equipment, and continuously monitor physical and emotional well-being throughout sessions.'
}, {
  question: 'How do I know if we are compatible?',
  answer: 'The screening process and consultation call are designed to assess compatibility. Trust your instincts, and know that I will also evaluate whether we are a good fit.'
}];
export function FAQ() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" ref={ref} className="py-24 lg:py-32 bg-onyx" data-id="element-139">
      <div className="max-w-4xl mx-auto px-6 lg:px-12" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-141">
          <p className="text-gold text-xs uppercase tracking-[0.3em] mb-4 font-cinzel" data-id="element-142">
            Frequently Asked Questions
          </p>
          <h2 className="font-cormorant text-bone text-4xl lg:text-6xl font-light mb-6" data-id="element-143">
            Common Inquiries
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-144">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className="border border-gold/10 bg-ink" data-id="element-145">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-onyx/50 transition-colors" data-id="element-146">
                <span className="font-cormorant text-bone text-xl pr-4" data-id="element-147">
                  {faq.question}
                </span>
                {openIndex === index ? <MinusIcon size={20} className="text-gold flex-shrink-0" data-id="element-148" /> : <PlusIcon size={20} className="text-gold flex-shrink-0" data-id="element-149" />}
              </button>
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} className="px-6 pb-6" data-id="element-150">
                  <p className="text-silver-muted leading-relaxed border-t border-gold/10 pt-4" data-id="element-151">
                    {faq.answer}
                  </p>
                </motion.div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}